import { DELIVERY_METHOD_NAMES } from '../../constants';
import { isSeleniumRunning } from './utils/testEnv';
import Raven from 'raven-js';
import { trackNotificationUsage } from './NotificationTracker';
import { propertiesFactory } from '../analytics/properties/propertiesFactory';
import { NOTIFICATION_TRACKER_NAMES, SIDEBAR_TRACKER_NAMES } from '../analytics/properties/types';
import getCurrentApp from '../getCurrentApp';
export function getSubscreen() {
  const NOT_AVAILABLE = 'not-available';
  const SUBSCREEN_REGEX = /\.[A-Za-z]+\/([^/]+)/;
  try {
    const currentParentUrl = window.parent.location.href;
    const urlParts = SUBSCREEN_REGEX.exec(currentParentUrl);
    return urlParts && urlParts[1] || NOT_AVAILABLE;
  } catch (e) {
    return '';
  }
}
function trackWithProperties(name, action, propertiesForThisKind = {}) {
  const properties = Object.assign({
    action,
    screen: getCurrentApp()
  }, propertiesForThisKind);
  try {
    if (!isSeleniumRunning()) {
      trackNotificationUsage(name, properties);
    }
    return true;
  } catch (e) {
    if (e instanceof Error) {
      Raven.captureException(e);
    }
    return false;
  }
}
function actionMetaCreator(name, notification, deliveryMethod, action, ...otherProps) {
  const {
    origin,
    template,
    type
  } = notification;
  const propertiesForThisKind = propertiesFactory(name, {
    deliveryMethod,
    originName: origin && origin.name,
    templateId: typeof template === 'object' ? template.id : template,
    typeId: typeof type === 'object' ? type.name : type
  }, notification);
  const additionalProps = otherProps.length ? Object.assign({}, propertiesForThisKind, ...otherProps) : propertiesForThisKind;
  return trackWithProperties(name, action, additionalProps);
}
export function interactionMetaCreator(notification, deliveryMethod, action, ...otherProps) {
  return actionMetaCreator(NOTIFICATION_TRACKER_NAMES.NOTIFICATION_INTERACTION, notification, deliveryMethod, action, ...(otherProps || []));
}
export function usageMetaCreator(notification, deliveryMethod, action) {
  return actionMetaCreator(NOTIFICATION_TRACKER_NAMES.NOTIFICATION_USAGE, notification, deliveryMethod, action);
}
export const browserNotificationInteractionCreator = (notification, action) => {
  return actionMetaCreator(NOTIFICATION_TRACKER_NAMES.BROWSER_NOTIFICATIONS_INTERACTION, notification, DELIVERY_METHOD_NAMES.BROWSER, action);
};
export const prePermissionPopupInteractionCreator = action => {
  return trackWithProperties(NOTIFICATION_TRACKER_NAMES.NOTIFICATION_INTERACTION, action);
};
function sidebarActionMetaCreator(name, action, otherParams = {}) {
  const otherProps = Object.assign({
    deliveryMethod: DELIVERY_METHOD_NAMES.SIDEBAR,
    subscreen: getSubscreen()
  }, otherParams);
  return trackWithProperties(name, action, otherProps);
}
export function sidebarInteractionMetaCreator(action, otherParams = {}) {
  return sidebarActionMetaCreator(SIDEBAR_TRACKER_NAMES.NOTIFICATION_SIDEBAR_INTERACTION, action, otherParams);
}